module.exports = __webpack_public_path__ + "static/img/kv_title.7425b47.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/teaser/kv_title.png
// module id = /RTL
// module chunks = 0